var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDownFilledX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92436 21.2608C9.60735 21.7491 10.451 21.5563 10.9584 21.094L16.4709 16.0712L16.4706 2.25H6.51074C5.13424 2.25 3.96979 3.26772 3.78549 4.63182L2.77034 12.1458C2.54741 13.7959 3.8305 15.264 5.49558 15.264L8.52189 15.264C7.85353 16.3597 7.49341 17.3611 7.44758 18.2707C7.38229 19.5663 7.95956 20.5711 8.92436 21.2608Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2072 15.75C21.1737 15.75 21.9572 14.9665 21.9572 14L21.9572 4.00002C21.9572 3.03353 21.1737 2.25002 20.2072 2.25002L17.8635 2.25002L17.8635 15.75H20.2072Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownFilledX2);
export default __webpack_public_path__ + "static/media/ThumbsDownFilledX2.8952292589c5b1ddd9431edd820dcb7a.svg";
export { ForwardRef as ReactComponent };